import { IdValue } from '../types/props';
import { defaultLangKey } from './local-storage';

export enum LangEnum {
  RU = 'ru',
  KZ = 'kz',
  CH = 'ch',
  EN = 'en',
}

export const langMap: Record<LangEnum, string> = {
  [LangEnum.RU]: 'Русский',
  [LangEnum.KZ]: 'Қазақша',
  [LangEnum.CH]: '中文',
  [LangEnum.EN]: 'English',
};

export const getDefaultLang = () => localStorage.getItem(defaultLangKey) as LangEnum;
export const validateLang = (data?: LangType): boolean => {
  return !!data?.[getDefaultLang()];
};

export const mapShortLangs: IdValue[] = Object.keys(langMap).map((lang) => ({
  id: lang,
  value: lang.toUpperCase(),
}));

export const mapFullLangs: IdValue[] = Object.keys(langMap).map((lang) => ({
  id: lang,
  value: langMap[lang as LangEnum],
}));

export type LangType = {
  [key in LangEnum]?: string;
};

export const isMainLangFilled = (mainLang: LangEnum, data?: LangType): boolean => {
  if (!data) {
    return false;
  }
  return Object.keys(data).every((lang) => {
    if (lang === mainLang) {
      return data[lang] !== '';
    }
    return true;
  });
};
